// Content of the public home page, adapted from inscription.casaclassroom.com.
// French is the reference; Arabic mirrors it. Other languages fall back to French.

export const WHATSAPP_URL = "https://wa.me/21628208393";
export const LEAD_ENDPOINT =
  "https://script.google.com/macros/s/AKfycbzHBUyX-9XA3cz11PFQ8hpwde4qI2RipnnallfwLt9m6hdMCqW1kl2aHB8TqKtAinN2/exec";
export const MEDIA = {
  video: "https://inscription.casaclassroom.com/assets/extrait-seance.mp4#t=0.5",
  audio: "https://inscription.casaclassroom.com/assets/temoignage.ogg",
  audioDuration: 76.7,
};

export const AGE_VALUES = [
  "5-6 ans",
  "7-8 ans",
  "9-10 ans",
  "11-12 ans",
  "13 ans et plus",
  "Plusieurs enfants",
];

const fr = {
  cta: { book: "Réserver la séance gratuite", short: "Séance gratuite" },
  r: {
    nocard: "Sans carte bancaire",
    nocommit: "Sans engagement",
    s40: "40 secondes",
    s20: "20 secondes",
    free: "Gratuit",
  },
  hero: {
    titleStart: "Votre enfant apprend ",
    titleHighlight: "l'arabe et le Coran",
    titleEnd: ", dans une langue qu'il comprend.",
    lead: "1 heure en visio, dès 5 ans, pour les enfants nés en Europe.",
    leadBold: "La séance d'essai est offerte.",
  },
  vid: {
    chip: "Extrait de séance",
    title: "Voir à quoi ressemble une séance",
    sub: "38 secondes",
    aria: "Lire l'extrait de séance",
  },
  qualif: ["Dès 5 ans", "Débutant accepté", "Soirs & week-ends"],
  recog: {
    eye: "Est-ce pour vous ?",
    h2: "Si vous vous reconnaissez ici, vous êtes au bon endroit.",
    cards: [
      "Votre enfant parle français, mais pas l'arabe.",
      "Aucun cours près de chez vous, ou des horaires impossibles.",
      "Vous avez essayé des vidéos : il décroche au bout de 5 minutes.",
      "Vous voulez qu'il aime ça — pas qu'il le subisse.",
    ],
    outT: "CasaClass a été construit exactement pour ces enfants-là.",
    outS: "Des professeurs tunisiens francophones, formés à enseigner à des enfants qui grandissent en Europe.",
  },
  proof: {
    eye: "Témoignage",
    h2: "Elle avait les mêmes doutes que vous.",
    sub: "Un message vocal brut, tel qu'elle nous l'a envoyé.",
    title: "Message vocal d'une maman",
    meta: "1 min 17 · reçu sur WhatsApp",
    play: "Écouter le témoignage",
    pause: "Pause",
    speed: "Vitesse de lecture",
    err: "La lecture a échoué sur ce navigateur.",
  },
  steps: {
    eye: "3 étapes",
    h2: "De ce bouton à la première séance : 48 heures.",
    items: [
      {
        title: "Vous répondez à 4 questions",
        text: "L'âge de votre enfant, son prénom, le vôtre, votre WhatsApp. 40 secondes.",
        meta: "Aucune carte bancaire",
      },
      {
        title: "On vous écrit sur WhatsApp",
        text: "En moins de 5 minutes en journée. On choisit ensemble le créneau qui vous arrange.",
        meta: "Vous gardez la main",
      },
      {
        title: "Séance d'essai gratuite d'1 heure",
        text: "Votre enfant rencontre son professeur. Vous décidez après — ou vous ne décidez pas.",
        meta: "Zéro engagement",
      },
    ],
  },
  offer: {
    eye: "Nos formules",
    h2: "Trois formules. Une séance d'essai pour choisir.",
    sub: "Le même professeur chaque semaine, un créneau fixe, et une heure de cours à chaque fois.",
    inclT: "Inclus dans les trois formules",
    incl: [
      "1 heure de cours par séance",
      "Le même professeur chaque semaine",
      "Coran : 3 enfants maximum par groupe",
      "Séance reportée, jamais perdue",
      "Bilan de progression chaque mois",
      "Professeur joignable sur WhatsApp",
    ],
    perMonth: " / mois",
    planCta: "Essayer cette formule",
    plans: [
      {
        id: "decouverte",
        name: "Découverte",
        freq: "1 séance par semaine",
        what: ["Arabe ", "ou", " Coran, au choix"],
        old: "45 €",
        price: "39 €",
        unit: ["soit ", "9,75 €", " la séance"],
      },
      {
        id: "semi",
        name: "Semi-intensif",
        freq: "2 séances par semaine",
        what: ["1 cours d'arabe ", "+", " 1 cours de Coran"],
        old: "79 €",
        price: "69 €",
        unit: ["soit ", "8,63 €", " la séance"],
        badge: "Recommandé",
      },
      {
        id: "intensif",
        name: "Intensif",
        freq: "3 séances par semaine",
        what: ["Arabe ", "et", " Coran en immersion"],
        old: "99 €",
        price: "89 €",
        unit: ["soit ", "7,42 €", " la séance"],
        bestUnit: true,
      },
    ],
    note: "Prix à la séance calculé sur 4 séances par mois.",
    extras: [
      {
        title: "Payer l'année : 3 mois offerts",
        text: "351 € · 621 € · 801 € selon la formule, au lieu de 12 mensualités.",
      },
      {
        title: "Plusieurs enfants : jusqu'à −20 %",
        text: "2ᵉ enfant −15 %, 3ᵉ enfant −20 %, cumulable avec les tarifs de rentrée. Deux enfants en Semi-intensif : 127,65 € au lieu de 138 €.",
      },
    ],
    gT: "Vous essayez avant de payer.",
    gS: "La séance d'essai est gratuite et sans carte bancaire. Ensuite, la formule mensuelle s'arrête quand vous le demandez, sans justification et sans préavis.",
    cta: "Commencer par la séance gratuite",
    compare: [
      { title: "L'école du samedi", text: "Trajet, groupe de 20, horaire imposé", mark: "Peu adapté" },
      { title: "Les vidéos en ligne", text: "Gratuit, mais personne ne corrige, personne ne suit", mark: "Abandon rapide" },
      { title: "CasaClass", text: "Coran à 3 enfants maximum, par âge et niveau", mark: "Adapté", win: true },
    ],
  },
  faq: {
    eye: "Objections",
    h2: "Les questions que tous les parents nous posent.",
    items: [
      {
        q: "Mon enfant ne parle pas un mot d'arabe. C'est bloquant ?",
        a: ["C'est le cas de la majorité de nos élèves. Tout est expliqué en français ; l'arabe arrive lettre par lettre. Un enfant qui n'a jamais entendu d'arabe à la maison peut commencer lundi prochain."],
      },
      {
        q: "Les séances sont-elles individuelles ou en groupe ?",
        a: [
          "En groupe, réuni par âge et par niveau. Pour le Coran, le groupe ne dépasse jamais 3 enfants : chacun lit à voix haute plusieurs fois par séance et le professeur corrige tout le monde. C'est aussi la formule de la séance d'essai gratuite.",
          "Le cours individuel existe si vous le préférez : dites-le nous sur WhatsApp et nous vous indiquons le tarif.",
        ],
      },
      {
        q: "Dois-je rester à côté pendant la séance ?",
        a: ["Vous faites comme vous préférez. Beaucoup de parents restent lors de la première séance puis laissent l'enfant seul. Les séances peuvent être enregistrées sur demande pour que vous les revoyiez."],
      },
      {
        q: "Qui sont les professeurs, exactement ?",
        a: [
          "Des enseignants tunisiens francophones, formés à l'enseignement du Coran aux enfants et sélectionnés autant sur leur douceur que sur leur niveau.",
          "Vous rencontrez le vôtre dès la séance gratuite, et vous pouvez demander à en changer si le courant ne passe pas.",
        ],
      },
      {
        q: "Combien ça coûte réellement ?",
        a: [
          "De 39 € à 89 € par mois selon le nombre de séances, sans frais d'inscription : 39 € pour une séance par semaine, 69 € pour deux, 89 € pour trois. Le 2ᵉ enfant bénéficie de −15 %, le 3ᵉ de −20 %.",
          "Payer trois mois ou un an d'avance réduit encore le tarif. Le cours individuel est possible : demandez-nous le tarif, il vous est annoncé avant que vous décidiez.",
        ],
      },
      {
        q: "Et si mon enfant n'accroche pas ?",
        a: [
          "Vous ne devez rien et vous n'avez rien à justifier. C'est précisément à ça que sert la séance gratuite : voir sa réaction avant de décider.",
          "Et si vous avez déjà commencé, l'abonnement s'arrête quand vous le demandez.",
        ],
      },
      {
        q: "Nos horaires sont compliqués. Vous vous adaptez ?",
        a: ["Les créneaux sont calés sur l'heure européenne : après l'école en semaine, ou le samedi et le dimanche. Si une semaine ne va pas, la séance est décalée plutôt que perdue."],
      },
      {
        q: "De quoi a-t-on besoin techniquement ?",
        a: ["Un téléphone, une tablette ou un ordinateur, et une connexion correcte. Vous recevez un lien à cliquer avant chaque séance : rien à installer."],
      },
      {
        q: "Que faites-vous de mon numéro ?",
        a: ["Il sert uniquement à organiser la séance de votre enfant. Aucune revente, aucune newsletter automatique, et vous pouvez demander sa suppression à tout moment."],
      },
    ],
  },
  final: {
    eye: "Dernière étape",
    h2: "Réservez la séance gratuite de votre enfant.",
    lead: "Vous n'avez pas besoin de parler arabe, ni d'avoir tout organisé. Juste de dire oui à une heure.",
    bullets: [
      "1 heure de cours, entièrement offerte",
      "Aucune carte bancaire demandée",
      "Réponse WhatsApp en moins de 5 minutes",
    ],
    waQ: "Vous préférez parler d'abord ?",
    waLink: "Écrivez-nous sur WhatsApp",
  },
  form: {
    step: "ÉTAPE {n} / 2",
    s1h: "Quel âge a votre enfant ?",
    s1sub: "Pour le placer dans le bon groupe de niveau.",
    ages: ["5–6 ans", "7–8 ans", "9–10 ans", "11–12 ans", "13 ans et plus", "Plusieurs enfants"],
    s1note: "Aucune information personnelle à cette étape.",
    s2h: "Où doit-on vous écrire ?",
    s2sub: "On vous propose 2 créneaux sur WhatsApp. Rien d'automatique.",
    parent: "Votre prénom",
    child: "Prénom de l'enfant",
    tel: "Votre numéro WhatsApp",
    phParent: "Amel",
    phChild: "Rayan",
    phTel: "+33 6 12 34 56 78",
    req: "Requis",
    errTel: "Indiquez un numéro valide",
    hint: "Un message, pas d'appel surprise. Jamais de démarchage.",
    back: "Modifier l'âge",
    privacy: "Vos données servent uniquement à organiser la séance. Aucune revente.",
    doneH: "C'est enregistré,",
    doneP: "On vous écrit sur WhatsApp dans les prochaines minutes pour fixer le créneau de",
    doneChild: "votre enfant",
    doneWa: "Ouvrir WhatsApp maintenant",
    doneClose: "Vous pouvez fermer cette fenêtre.",
    close: "Fermer",
  },
};

const ar = {
  cta: { book: "احجز الحصّة المجّانية", short: "حصّة مجّانية" },
  r: {
    nocard: "بدون بطاقة بنكية",
    nocommit: "بدون التزام",
    s40: "40 ثانية",
    s20: "20 ثانية",
    free: "مجّاناً",
  },
  hero: {
    titleStart: "طفلك يتعلّم ",
    titleHighlight: "العربية والقرآن",
    titleEnd: "، بلغة يفهمها.",
    lead: "ساعة واحدة عبر الإنترنت، من سنّ الخامسة، للأطفال المولودين في أوروبا.",
    leadBold: "الحصّة التجريبية مجّانية.",
  },
  vid: {
    chip: "مقتطف من حصّة",
    title: "شاهد كيف تجري الحصّة",
    sub: "38 ثانية",
    aria: "شغّل مقتطف الحصّة",
  },
  qualif: ["من سنّ الخامسة", "المبتدئون مرحّب بهم", "مساءً وعطلة نهاية الأسبوع"],
  recog: {
    eye: "هل هذا يخصّك؟",
    h2: "إن وجدت نفسك هنا، فأنت في المكان الصحيح.",
    cards: [
      "طفلك يتكلّم الفرنسية، لكنّه لا يعرف العربية.",
      "لا توجد دروس قريبة منك، أو المواعيد مستحيلة.",
      "جرّبت الفيديوهات: يفقد تركيزه بعد خمس دقائق.",
      "تريده أن يحبّ هذا التعلّم، لا أن يتحمّله.",
    ],
    outT: "كازا كلاس أُنشئت خصّيصاً لهؤلاء الأطفال.",
    outS: "معلّمون تونسيون يتقنون الفرنسية، مدرَّبون على تعليم أطفال يكبرون في أوروبا.",
  },
  proof: {
    eye: "شهادة",
    h2: "كانت لديها نفس الشكوك التي لديك.",
    sub: "رسالة صوتية كما وصلتنا، دون أيّ تعديل.",
    title: "رسالة صوتية من أمّ",
    meta: "دقيقة و17 ثانية · وصلتنا عبر واتساب",
    play: "استمع إلى الشهادة",
    pause: "إيقاف مؤقّت",
    speed: "سرعة التشغيل",
    err: "تعذّر تشغيل الصوت على هذا المتصفّح.",
  },
  steps: {
    eye: "ثلاث خطوات",
    h2: "من هذا الزرّ إلى الحصّة الأولى: 48 ساعة.",
    items: [
      {
        title: "تجيب عن أربعة أسئلة",
        text: "عمر طفلك، اسمه، اسمك، ورقم واتساب. أربعون ثانية.",
        meta: "بدون بطاقة بنكية",
      },
      {
        title: "نراسلك على واتساب",
        text: "في أقلّ من خمس دقائق خلال النهار. نختار معاً الموعد الذي يناسبك.",
        meta: "القرار بيدك",
      },
      {
        title: "حصّة تجريبية مجّانية من ساعة",
        text: "يلتقي طفلك بمعلّمه. تقرّر بعدها — أو لا تقرّر شيئاً.",
        meta: "بدون أيّ التزام",
      },
    ],
  },
  offer: {
    eye: "صيغنا",
    h2: "ثلاث صيغ. وحصّة تجريبية لتختار.",
    sub: "نفس المعلّم كلّ أسبوع، وموعد ثابت، وساعة كاملة في كلّ حصّة.",
    inclT: "مشترك بين الصيغ الثلاث",
    incl: [
      "ساعة كاملة من الدرس في كلّ حصّة",
      "نفس المعلّم كلّ أسبوع",
      "القرآن: 3 أطفال على الأكثر في المجموعة",
      "الحصّة تُؤجَّل ولا تضيع",
      "تقرير تقدّم كلّ شهر",
      "المعلّم متاح على واتساب",
    ],
    perMonth: " / شهرياً",
    planCta: "جرّب هذه الصيغة",
    plans: [
      {
        id: "decouverte",
        name: "اكتشاف",
        freq: "حصّة واحدة أسبوعياً",
        what: ["عربية ", "أو", " قرآن، حسب الاختيار"],
        old: "45 €",
        price: "39 €",
        unit: ["أي ", "9,75 €", " للحصّة"],
      },
      {
        id: "semi",
        name: "شبه مكثّف",
        freq: "حصّتان أسبوعياً",
        what: ["درس عربية ", "+", " درس قرآن"],
        old: "79 €",
        price: "69 €",
        unit: ["أي ", "8,63 €", " للحصّة"],
        badge: "صيغتنا المقترحة",
      },
      {
        id: "intensif",
        name: "مكثّف",
        freq: "ثلاث حصص أسبوعياً",
        what: ["عربية ", "وقرآن", " في انغماس كامل"],
        old: "99 €",
        price: "89 €",
        unit: ["أي ", "7,42 €", " للحصّة"],
        bestUnit: true,
      },
    ],
    note: "سعر الحصّة محسوب على أساس 4 حصص في الشهر.",
    extras: [
      {
        title: "الدفع السنوي: 3 أشهر مجّاناً",
        text: "351 € · 621 € · 801 € حسب الصيغة، بدل اثني عشر قسطاً شهرياً.",
      },
      {
        title: "عدّة أطفال: حتّى −20 %",
        text: "الطفل الثاني −15 %، والثالث −20 %، وتُجمع مع أسعار الدخول المدرسي. طفلان في الصيغة شبه المكثّفة: 127,65 € بدل 138 €.",
      },
    ],
    gT: "تجرّب قبل أن تدفع.",
    gS: "الحصّة التجريبية مجّانية وبدون بطاقة بنكية. وبعدها، الصيغة الشهرية تتوقّف متى طلبت، دون تبرير ودون إشعار مسبق.",
    cta: "ابدأ بالحصّة المجّانية",
    compare: [
      { title: "مدرسة يوم السبت", text: "تنقّل، مجموعة من 20 طفلاً، موعد مفروض", mark: "غير مناسب" },
      { title: "الفيديوهات على الإنترنت", text: "مجّانية، لكن لا أحد يصحّح ولا أحد يتابع", mark: "انقطاع سريع" },
      { title: "CasaClass", text: "القرآن في مجموعة من 3 أطفال على الأكثر، حسب السنّ والمستوى", mark: "مناسب", win: true },
    ],
  },
  faq: {
    eye: "أسئلتكم",
    h2: "الأسئلة التي يطرحها علينا كلّ الأولياء.",
    items: [
      {
        q: "طفلي لا يعرف كلمة واحدة بالعربية. هل هذا عائق؟",
        a: ["هذه حال أغلب تلاميذنا. كلّ شيء يُشرح بلغة يفهمها الطفل، والعربية تأتي حرفاً بعد حرف. طفل لم يسمع العربية في البيت قطّ يمكنه أن يبدأ الاثنين القادم."],
      },
      {
        q: "هل الحصص فردية أم في مجموعة؟",
        a: [
          "في مجموعة، يُجمَع أفرادها حسب السنّ والمستوى. وفي القرآن لا تتجاوز المجموعة ثلاثة أطفال: يقرأ كلّ طفل بصوت عالٍ عدّة مرّات في الحصّة ويصحّح المعلّم للجميع. وهذه أيضاً صيغة الحصّة التجريبية المجّانية.",
          "الدرس الفردي متاح إن كنت تفضّله: أخبرنا على واتساب ونعلمك بالسعر.",
        ],
      },
      {
        q: "هل يجب أن أبقى بجانبه أثناء الحصّة؟",
        a: ["كما تفضّل. كثير من الأولياء يبقون في الحصّة الأولى ثمّ يتركون الطفل وحده. ويمكن تسجيل الحصص عند الطلب لتشاهدها لاحقاً."],
      },
      {
        q: "من هم المعلّمون بالضبط؟",
        a: [
          "معلّمون تونسيون يتقنون الفرنسية، مدرَّبون على تعليم القرآن للأطفال، ومُختارون على أساس لطفهم بقدر ما هم مُختارون على أساس مستواهم.",
          "تلتقي بمعلّم طفلك منذ الحصّة المجّانية، ويمكنك طلب تغييره إن لم يحصل الانسجام.",
        ],
      },
      {
        q: "كم يكلّف هذا فعلياً؟",
        a: [
          "من 39 € إلى 89 € شهرياً حسب عدد الحصص، بدون رسوم تسجيل: 39 € لحصّة واحدة أسبوعياً، 69 € لحصّتين، 89 € لثلاث. الطفل الثاني يستفيد من −15 %، والثالث من −20 %.",
          "الدفع لثلاثة أشهر أو لسنة يخفّض السعر أكثر. والدرس الفردي ممكن: اطلب منّا السعر، ويُعلَن لك قبل أن تقرّر.",
        ],
      },
      {
        q: "وإن لم يتعلّق طفلي بالأمر؟",
        a: [
          "لا شيء عليك، ولا يلزمك أيّ تبرير. هذا بالضبط دور الحصّة المجّانية: أن ترى ردّ فعل طفلك قبل أن تقرّر.",
          "وإن كنت قد بدأت فعلاً، يتوقّف الاشتراك متى طلبت ذلك.",
        ],
      },
      {
        q: "مواعيدنا معقّدة. هل تتأقلمون معها؟",
        a: ["المواعيد مضبوطة على التوقيت الأوروبي: بعد المدرسة في أيام الأسبوع، أو يوم السبت والأحد. وإن لم يناسبك أسبوع ما، تُؤجَّل الحصّة بدل أن تضيع."],
      },
      {
        q: "ما الذي نحتاجه من ناحية تقنية؟",
        a: ["هاتف أو لوحة أو حاسوب، واتّصال إنترنت جيّد. يصلك رابط تضغط عليه قبل كلّ حصّة: لا شيء يُثبَّت."],
      },
      {
        q: "ماذا تفعلون برقم هاتفي؟",
        a: ["يُستعمل فقط لتنظيم حصّة طفلك. لا بيع للبيانات، ولا رسائل إعلانية آلية، ويمكنك طلب حذفه في أيّ وقت."],
      },
    ],
  },
  final: {
    eye: "الخطوة الأخيرة",
    h2: "احجز الحصّة المجّانية لطفلك.",
    lead: "لا تحتاج إلى إتقان العربية، ولا إلى ترتيب كلّ شيء. تحتاج فقط أن تقول نعم لساعة واحدة.",
    bullets: [
      "ساعة كاملة من الدرس، مجّاناً",
      "لا نطلب أيّ بطاقة بنكية",
      "ردّ على واتساب في أقلّ من 5 دقائق",
    ],
    waQ: "تفضّل أن تتحدّث أوّلاً؟",
    waLink: "راسلنا على واتساب",
  },
  form: {
    step: "الخطوة {n} / 2",
    s1h: "كم عمر طفلك؟",
    s1sub: "لوضعه في مجموعة المستوى المناسبة.",
    ages: ["5–6 سنوات", "7–8 سنوات", "9–10 سنوات", "11–12 سنة", "13 سنة فما فوق", "أكثر من طفل"],
    s1note: "لا نطلب أيّ معلومة شخصية في هذه الخطوة.",
    s2h: "أين نراسلك؟",
    s2sub: "نقترح عليك موعدين على واتساب. لا شيء آلي.",
    parent: "اسمك",
    child: "اسم طفلك",
    tel: "رقم واتساب",
    phParent: "آمال",
    phChild: "ريان",
    phTel: "+33 6 12 34 56 78",
    req: "مطلوب",
    errTel: "أدخل رقماً صحيحاً",
    hint: "رسالة واحدة، لا مكالمات مفاجئة. ولا تسويق إطلاقاً.",
    back: "تغيير العمر",
    privacy: "بياناتك تُستعمل فقط لتنظيم الحصّة. لا بيع لها.",
    doneH: "تمّ التسجيل،",
    doneP: "نراسلك على واتساب خلال دقائق لتحديد موعد حصّة",
    doneChild: "طفلك",
    doneWa: "افتح واتساب الآن",
    doneClose: "يمكنك إغلاق هذه النافذة.",
    close: "إغلاق",
  },
};

const CONTENT = { fr, ar };

export function getHomeContent(language) {
  return CONTENT[language] || CONTENT.fr;
}
